import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../../styles";
import SettingsWrapper from "../../../layout/SettingsWrapper";
import AllPackages from "../packages/AllPackages";

function Upgrade() {

  return (
    <>
      <SettingsWrapper
        title="UPGRADE">
        {/* <div className="text-center mb-4">
          <Link to='/user/settings/packages'>
            <Button pry className="btn">choose a package</Button>
          </Link>
        </div> */}

        <AllPackages />
      </SettingsWrapper>

    </>
  );
}

export default Upgrade;
